<template>
  <section>
    <div v-if="loading">
      <!-- Filter -->
      <div class="intro-y flex flex-col-reverse mt-3 sm:flex-row items-center">
        <h2 class="intro-y text-lg font-medium mr-auto mt-2">
          Presupuestos ({{ pagination.total }})
        </h2>
        <!-- Form -->
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
          <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
            <app-icon
              v-bind:name="'search'"
              v-bind:classname="'w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700'"
            ></app-icon>
            <input
              type="text"
              class="input w-full sm:w-64 box px-10 text-gray-700"
              placeholder="Buscar por código"
              v-model="filter.slug"
            />
          </div>

          <div
            class="inbox-filter dropdown absolute inset-y-0 mr-3 right-0 flex items-center"
          >
            <app-icon
              name="chevron-down"
              classname="dropdown-toggle w-4 h-4 cursor-pointer text-gray-700"
            />
            <div
              class="inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
            >
              <div class="dropdown-box__content box p-5">
                <div class="grid grid-cols-12 gap-4 row-gap-3">
                  <div class="col-span-6">
                    <div class="text-xs">Cuenta</div>
                    <select
                      class="input w-full border mt-2 flex-13"
                      v-model="filter.account"
                    >
                      <option :value="null">Seleccione una opción</option>
                      <option
                        v-for="account in accounts"
                        :value="account.id"
                        :key="account.id"
                      >
                        {{ account.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-span-6">
                    <div class="text-xs">Cliente</div>
                    <select
                      class="input w-full border mt-2 flex-13"
                      v-model="filter.client"
                    >
                      <option :value="null">Seleccione una opción</option>
                      <option
                        v-for="client in clients"
                        :value="client.id"
                        :key="client.id"
                      >
                        {{ client.social_reason }}
                      </option>
                    </select>
                  </div>
                  <div class="col-span-6">
                    <div class="text-xs">Mes</div>
                    <select
                      class="input w-full border mt-2 flex-13"
                      v-model="filter.month"
                    >
                      <option :value="null">Seleccione una opción</option>
                      <option
                        v-for="month in months"
                        :value="month.id"
                        :key="month.id"
                      >
                        {{ month.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-span-6">
                    <div class="w-full sm:w-auto flex">
                      <button
                        @click="filter = clearFilter()"
                        class="button mt-28 text-white bg-theme-1 shadow-md mr-2"
                      >
                        Borrar Filtro
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end form -->
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"></div>
        <div class="w-full sm:w-auto flex">
          <router-link
            to="/admin/business/budgets/create"
            class="button text-white bg-theme-1 shadow-md mr-2"
          >
            Crear Presupuesto
          </router-link>
        </div>
      </div>
      <!-- END: Filter -->

      <!-- List -->
      <div class="intro-y flex overflow-auto">
        <table class="table table-report -mt-2">
          <thead>
            <tr>
              <th class="text-center whitespace-no-wrap">CÓDIGO</th>
              <th class="text-center whitespace-no-wrap">REFERENCIA</th>
              <th class="text-center whitespace-no-wrap">TIPO</th>
              <th class="text-center whitespace-no-wrap">SUBTOTAL</th>
              <th class="text-center whitespace-no-wrap">TOTAL</th>
              <th class="text-center whitespace-no-wrap">ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="intro-x"
              v-for="budget in filteredBudgets"
              :key="`budget-${budget.id}`"
            >
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ budget.slug }} - {{ budget.version_count }}
                </div>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ budget.reference | limit }}
                </div>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ budget.type }}
                </div>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  $ {{ formatPrice(budget.latest_version.subtotal) }}
                </div>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  $ {{ formatPrice(budget.latest_version.total) }}
                </div>
              </td>
              <td class="table-report__action w-56">
                <div class="flex justify-center items-center">
                  <router-link
                    :to="`/admin/business/budgets/show/${budget.id}`"
                    class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md"
                  >
                    <app-icon name="folder" classname="w-4 h-4 mr-2" />Detalle
                  </router-link>
                </div>
                <div class="flex justify-center items-center">
                  <a
                    :href="`/v1/api/budget/download/${budget.id}`"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md"
                  >
                    <app-icon name="folder" classname="w-4 h-4 mr-2" />Ver PDF
                  </a>
                </div>
                <div class="flex justify-center items-center">
                  <a
                    :href="`/v1/api/budget/download-complete/${budget.id}`"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md"
                  >
                    <app-icon name="folder" classname="w-4 h-4 mr-2" />PDF
                    Completo
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- END: List -->

      <!-- Pagination -->
      <div class="intro-y flex flex-wrap sm:flex-row sm:flex-no-wrap items-center mt-3">
        <ul class="pagination">
          <li>
            <a
              class="pagination__link text-theme-1"
              :class="{ 'pagination__link--disabled': pagination.currentPage <= 1 }"
              @click="changePage(1)"
            >
              <app-icon name="chevrons-left" classname="w-4 h-4" />
            </a>
          </li>
          <li>
            <a
              class="pagination__link text-theme-1"
              :class="{ 'pagination__link--disabled': pagination.currentPage <= 1 }"
              @click="changePage(pagination.currentPage - 1)"
            >
              <app-icon name="chevron-left" classname="w-4 h-4" />
            </a>
          </li>
          <li v-for="page in paginationPages" :key="'page-' + page">
            <a
              class="pagination__link text-theme-1"
              :class="{ 'pagination__link--active': page === pagination.currentPage }"
              @click="changePage(page)"
            >
              {{ page }}
            </a>
          </li>
          <li>
            <a
              class="pagination__link text-theme-1"
              :class="{ 'pagination__link--disabled': pagination.currentPage >= pagination.lastPage }"
              @click="changePage(pagination.currentPage + 1)"
            >
              <app-icon name="chevron-right" classname="w-4 h-4" />
            </a>
          </li>
          <li>
            <a
              class="pagination__link text-theme-1"
              :class="{ 'pagination__link--disabled': pagination.currentPage >= pagination.lastPage }"
              @click="changePage(pagination.lastPage)"
            >
              <app-icon name="chevrons-right" classname="w-4 h-4" />
            </a>
          </li>
        </ul>
        <select class="input box mt-3 sm:mt-0 w-20" v-model.number="pagination.perPage" @change="changePage(1)">
          <option>10</option>
          <option>15</option>
          <option>25</option>
          <option>50</option>
        </select>
      </div>
      <!-- END: Pagination -->
    </div>

    <app-loading v-else />
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'AdminListBudget',
  data() {
    return {
      loading: false,
      boxedit: false,
      supplier: this.defineSupplier(),
      supplier_current: {},
      filter: this.clearFilter(),
      pagination: {
        currentPage: 1,
        lastPage: 1,
        total: 0,
        perPage: 15,
      },
      months: [
        { id: '01', name: 'ENERO' },
        { id: '02', name: 'FEBRERO' },
        { id: '03', name: 'MARZO' },
        { id: '04', name: 'ABRIL' },
        { id: '05', name: 'MAYO' },
        { id: '06', name: 'JUNIO' },
        { id: '07', name: 'JULIO' },
        { id: '08', name: 'AGOSTO' },
        { id: '09', name: 'SEPTIEMBRE' },
        { id: '10', name: 'OCTUBRE' },
        { id: '11', name: 'NOVIEMBRE' },
        { id: '12', name: 'DICIEMBRE' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      suppliers: 'getSuppliers',
      countries: 'getAccountCountries',
      accounts: 'getAccounts',
      budgets: 'getBudgets',
      clients: 'getClients',
    }),
    filteredBudgets: function () {
      return this.budgets.filter((item) => {
        let slug = this.filter.slug
          ? item.slug.toLowerCase().includes(this.filter.slug.toLowerCase())
          : true
        let account = this.filter.account
          ? this.filter.account == item.account_id
          : true
        let client = this.filter.client
          ? this.filter.client == item.client_id
          : true
        let month = this.filter.month
          ? this.filter.month == item.created_at.substr(5, 2)
          : true

        return slug && account && client && month
      })
    },
    paginationPages() {
      const pages = []
      const current = this.pagination.currentPage
      const last = this.pagination.lastPage
      const start = Math.max(1, current - 2)
      const end = Math.min(last, current + 2)
      for (let i = start; i <= end; i++) {
        pages.push(i)
      }
      return pages
    },
  },
  async beforeMount() {
    try {
      await this.getAll('supplier')
      await this.getList('accountcountry')
      await this.getList('account')
      await this.fetchBudgets()
      await this.getList('client')

      this.loading = true
    } catch (error) {}
  },
  methods: {
    defineSupplier() {
      return {
        social_reason: null,
        contact: null,
        nit: null,
        address: null,
        telphone: null,
        cellphone: null,
        email: null,
        link: null,
        entity: 'supplier',
      }
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    clearFilter() {
      return {
        account: null,
        client: null,
        month: null,
        slug: '',
      }
    },
    async fetchBudgets() {
      const params = `page=${this.pagination.currentPage}&per_page=${this.pagination.perPage}`
      const response = await this.getList(['budget', params])
      if (response.pagination) {
        this.pagination.currentPage = response.pagination.current_page
        this.pagination.lastPage = response.pagination.last_page
        this.pagination.total = response.pagination.total
        this.pagination.perPage = response.pagination.per_page
      }
    },
    async changePage(page) {
      if (page < 1 || page > this.pagination.lastPage) return
      this.pagination.currentPage = page
      await this.fetchBudgets()
    },
    ...mapActions(['getAll', 'getList', 'store', 'update']),
  },
  components: {
    appIcon: Icon,
    appLoading: Loading,
  },
}
</script>



// WEBPACK FOOTER //
// ListBudget.vue?6cacf089